export const name = 'pd_resolve';
export const label = 'Resolve Incident';
export const AdditionalParams = () => null;
export const type = 'incident_create,incident_update';
